import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigProvider from '../ConfigProvider';
export default function CardHeader(_ref) {
  var className = _ref.className,
      level = _ref.level,
      children = _ref.children,
      right = _ref.right,
      breadcrumb = _ref.breadcrumb;
  var main = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-card-header-left"
  }, children), right && /*#__PURE__*/React.createElement("div", {
    className: "jmtd-card-header-right"
  }, right));
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    titleLevel: level
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-card-header', className, {
      'jmtd-card-header-3': level === 3,
      'jmtd-card-header-5': level === 5,
      'jmtd-card-header-with-breadcrumb': !!breadcrumb
    })
  }, breadcrumb ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-card-header-left-with-breadcrumb"
  }, /*#__PURE__*/React.createElement(ConfigProvider, {
    size: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-card-header-breadcrumb"
  }, breadcrumb))), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-card-header-main"
  }, main)) : main));
}
CardHeader.propTypes = {
  className: PropTypes.string,
  level: PropTypes.number,
  children: PropTypes.node,
  right: PropTypes.node,
  breadcrumb: PropTypes.node
};
CardHeader.defaultProps = {
  className: '',
  level: 4,
  children: null,
  right: null,
  breadcrumb: null
};